import { Component, OnInit, Input } from '@angular/core';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-update-email',
  templateUrl: './update-email.component.html',
  styleUrls: ['./update-email.component.sass']
})
export class UpdateEmailComponent implements OnInit {
  
  @Input() email:string;
  @Input() cel:string;
  @Input() homeNum:string;
  public submitted:boolean;
  public email1:string;
  public email2:string;
  public newEmail;
  public selectBan:string;
  constructor(private services: Service,private global:GlobalService,private loadingScreenService :LoadingScreenService) { }

  ngOnInit() {
    if(this.global.sessionReview()==true){
      this.submitted = false;
      this.selectBan=atob(sessionStorage.getItem("selectBan"));
      this.email1='';
      this.email2='';
    }
  }
  continueEmail() {
    this.global.validateSession();
    if(this.cel==''){
      this.cel='7870000000';
    }
    if (this.email1 === '' && this.email2 === '') {
        this.newEmail = this.email;
         this.global.notif("Debe ingresar su correo electrónico");
    }
    else if (this.email1 === this.email2)  {
            this.newEmail = this.email1;
            if (this.global.validarEmail (this.email1) === false) {
                this.global.notif("Estimado cliente, el Nuevo Correo Electrónico tiene un formato incorrecto.");
            }
            else{
              this.loadingScreenService.startLoading();
                this.services.getVerifyEmail(this.newEmail).subscribe(data =>{
                  if(data.hasErrorField ==false){  
                    this.services.updatePersonalData(sessionStorage.getItem("token"),btoa(this.selectBan), btoa(this.cel),btoa(this.homeNum),btoa(this.newEmail)).subscribe(data =>{
                      this.loadingScreenService.stopLoading();
                      if(data.hasError ==false){
                        this.global.notif(data.errorDesc);
                        this.email=this.newEmail;
                        this.email1="";
                        this.email2="";
                      }
                      else{
                        this.global.notif(data.errorDesc);
                      }
                    });
                  }
                  else{
                    this.loadingScreenService.stopLoading();
                    this.global.notif(data.errorDescField);
                  }
                });
            }
        }
        else {
             this.global.notif("Los correos no coinciden.");
        }
  }
}